exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".position-card[data-v-39ee02b2]{margin-bottom:10px}.thumb-image[data-v-39ee02b2]{width:200px;height:200px;margin:auto}.thumb-image img[data-v-39ee02b2]{width:100%;height:100%;overflow:hidden}.interactive[data-v-39ee02b2]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39ee02b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-positions-thumbnail.vue
// module id = 91
// module chunks = 0